import labelsSettingsSaga from './labels-settings.saga';

export default labelsSettingsSaga;
